import { Button } from '@cian/ui-kit';
import { forwardRef } from 'react';

import styles from './FilterButtonV2.css';

interface IFilterButtonProps {
  children: string;
  beforeIcon?: JSX.Element;
  afterIcon?: JSX.Element;
  onClick: VoidFunction;
  flexible?: boolean;
}

export const FilterButtonV2 = forwardRef<HTMLButtonElement, IFilterButtonProps>(function FilterButton(
  { children, beforeIcon, afterIcon, onClick, flexible = false },
  ref,
) {
  return (
    <div className={flexible ? styles['flexible'] : undefined}>
      <div className={styles['small-button']}>
        <Button
          beforeIcon={beforeIcon}
          afterIcon={afterIcon}
          onClick={onClick}
          theme="fill_white_primary"
          ref={ref}
          size="M"
          tabIndex={0}
        />
      </div>

      <div className={styles['button']}>
        <Button
          beforeIcon={beforeIcon}
          afterIcon={afterIcon}
          onClick={onClick}
          theme="fill_white_primary"
          ref={ref}
          size="M"
          tabIndex={0}
        >
          {children}
        </Button>
      </div>
    </div>
  );
});
